module.exports = __webpack_public_path__ + "static/media/vector-dark.8ebb6db9.svg";